import { americanStyleUiConfig } from './american-style/ui-config';
import { dogueUiConfig } from './dogue/ui-config';
import { openCastingUiConfig } from './open-casting/ui-config';
import {
  OPEN_CALL_TYPE_IDS,
  OpenCallTypeId,
  OpenCallTypeUiConfig,
} from './types';

const OPEN_CALL_TYPE_UI_CONFIGS: Record<OpenCallTypeId, OpenCallTypeUiConfig> =
  {
    [OPEN_CALL_TYPE_IDS.OpenCasting]: openCastingUiConfig,
    [OPEN_CALL_TYPE_IDS.AmericanStyle]: americanStyleUiConfig,
    [OPEN_CALL_TYPE_IDS.Dogue]: dogueUiConfig,
  };

export function isOpenCallTypeId(
  typeId?: null | string,
): typeId is OpenCallTypeId {
  return typeId
    ? Object.prototype.hasOwnProperty.call(OPEN_CALL_TYPE_UI_CONFIGS, typeId)
    : false;
}

export function getOpenCallTypeUiConfig(
  typeId?: null | string,
): OpenCallTypeUiConfig {
  return (
    OPEN_CALL_TYPE_UI_CONFIGS[typeId as OpenCallTypeId] ?? openCastingUiConfig
  );
}

export { OPEN_CALL_TYPE_UI_CONFIGS };
